var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"home",attrs:{"fluid":""}},[_c('Hacks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }